const scopes = ['sp_organization', 'configuration'];

export function expandAdminPermissions(codenames) {
  const permissions = new Set(codenames);
  scopes.forEach(scope => {
    if (permissions.has('take_admin_actions')) permissions.add(`edit_admin_${scope}`);
    if (permissions.has('view_admin') || permissions.has(`edit_admin_${scope}`)) {
      permissions.add(`view_admin_${scope}`);
    }
  });
  return [...permissions];
}

export function splitAdminModules(modules) {
  // Keep the old editor usable while the web/API deployments are rolling out.
  const codenames = new Set(modules.flatMap(module => module.permissions.map(p => p.codename)));
  const canSplit = scopes.every(scope =>
    codenames.has(`view_admin_${scope}`) && codenames.has(`edit_admin_${scope}`));
  return canSplit ? modules.map(module =>
    module.permissions.some(p => p.codename === 'view_admin')
      ? { ...module, permissions: module.permissions.filter(p =>
          p.codename !== 'view_admin' && p.codename !== 'take_admin_actions') }
      : module).filter(module => module.permissions.length > 0).map(module => (
      module.permissions.some(p => scopes.some(scope => p.codename === `view_admin_${scope}`))
        ? { ...module, permissions: [...module.permissions].sort((a, b) =>
          Number(b.codename.startsWith('view_')) - Number(a.codename.startsWith('view_'))) }
        : module
    )) : modules;
}

export function expandAdminPermissionIds(ids, modules) {
  if (splitAdminModules(modules) === modules) return ids;
  const permissions = modules.flatMap(module => module.permissions);
  const selected = new Set(ids);
  const codenames = expandAdminPermissions(
    permissions.filter(p => selected.has(p.id)).map(p => p.codename));
  permissions.forEach(permission => {
    if (permission.codename === 'view_admin' || permission.codename === 'take_admin_actions') {
      selected.delete(permission.id);
    } else if (codenames.includes(permission.codename)) {
      selected.add(permission.id);
    }
  });
  return [...selected];
}
